import React from 'react';
import { Table } from 'semantic-ui-react';
import { findError } from '@/utils/errors';
import fields from '@/constants/fields';
import RowDeleteButton from '@/components/buttons/RowDeleteButton';
import VocabularyRoleActionCell from './VocabularyRoleActionCell';

const VocabularyRoleActionRow = ({
  activeRoleActionUUID,
  deleteRoleAction,
  onSelected,
  roleAction,
  updateErrors,
}) => {
  const errors = updateErrors.filter(({ context: { uuid } }) => uuid === roleAction.uuid);
  const nameError = findError(errors, 'link', [fields.NAME]);
  const titleError = findError(errors, 'link', [fields.TITLE]);

  return (
    <Table.Row
      active={roleAction.uuid === activeRoleActionUUID}
      className="pointer"
      error={!!errors.length}
      onClick={() => onSelected(roleAction.uuid)}
    >
      <VocabularyRoleActionCell
        content={roleAction.name}
        code
        field="name"
        hasError={!!errors.length}
        iconTitle={nameError?.message || errors[0]?.message}
      />
      <VocabularyRoleActionCell
        content={roleAction.title}
        field="title"
        hasError={!!titleError}
        iconTitle={titleError?.message}
      />
      <Table.Cell collapsing textAlign="center">
        <RowDeleteButton
          entity="vocabulary.role.action"
          onClick={(event) => {
            event.stopPropagation();
            deleteRoleAction(roleAction.uuid);
          }}
        />
      </Table.Cell>
    </Table.Row>
  );
};

export default VocabularyRoleActionRow;
